define(["angular",
        "../../userManagementModule"],
    function (angular, userManagementModule) {
        "use strict";

        return userManagementModule.controller("UserManagementUserEditionController", [
            "$scope",
            "user",
            "$state",
            "autocompleteFactory",
            "userManagementService",
            "remoteExceptionHandler",
            "loadingService",
            "messagesModal",
            "$window",
            function ($scope, user, $state, autocompleteFactory, userManagementService, remoteExceptionHandler, loadingService, messagesModal, $window) {
                $scope.user = user;

                $scope.isNewInstance = function () {
                    return !angular.isNumber(user.id);
                };

                $scope.availablesPermissionGroup = [];
                if(!!user.permissionGroup) {
                    userManagementService.findAllChildrenHierarchyTreeById(user.permissionGroup.id)
                        .then(function (value) {
                            $scope.availablesPermissionGroup = value;
                        });
                }

                $scope.restrictedProfiles = function () {
                    return userManagementService.findRestrictedProfiles();
                };

                $scope.passwordFields = {
                    password: "",
                    confirmation: ""
                };

                $scope.saveAndContinue = function () {
                    $scope.saveUser(true);
                }

                $scope.disabledButtons = function ()  {
                    if ($scope.passwordFields.password !== "" && $scope.passwordFields.confirmation !== "") {
                        return false;
                    }
                    return true;
                }

                $scope.saveUser = function (saveAndContinue) {
                    if ($scope.passwordFields.password !== "" || $scope.passwordFields.confirmation !== "") {
                        if ($scope.passwordFields.password === $scope.passwordFields.confirmation) {
                            $scope.user.password = $scope.passwordFields.password;
                            return doSaveUser(saveAndContinue);
                        } else {
                            return messagesModal("dialog.warning", [{
                                keyBundle: "entity.validator.passwordConfirmation",
                                parameters: []
                            }]);
                        }
                    } else {
                        return doSaveUser(saveAndContinue);
                    }
                };

                function doSaveUser(saveAndContinue) {
                    if ($scope.user.customizedReadOnly) {
                        return messagesModal.confirmation("dialog.warning", ["user.management.user.create.confirmation.customized"])
                            .then(function () {
                                    return saveAndReload(saveAndContinue);
                                }
                            );
                    } else {
                        return saveAndReload(saveAndContinue);
                    }
                }

                $scope.isPasswordValid = false;

                const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!]).{8,}$/;

                $scope.validatePassword = function(password) {
                    $scope.isPasswordValid = passwordRegex.test(password);
                };

                function saveAndReload(saveAndContinue) {
                    return loadingService(userManagementService.saveUser($scope.user)
                        .catch(remoteExceptionHandler())
                        .then(function (id) {
                            return messagesModal("dialog.success", [{
                                keyBundle: "entity.validator.successMessage",
                                parameters: []
                            }]).finally(function () {
                                setToPlaceholder();
                                if (saveAndContinue) {
                                    return $window.location.reload()
                                }
                                return $state.go("userManagement.userEdit", {
                                    userId: id
                                });
                            });
                        }));
                }

                $scope.back = function () {
                    return $state.go("userManagement.user", {
                        reload: true
                    });
                };

                $scope.getPlaceholder = function(user) {
                    if (user.id && !$scope.passwordFields.password && !$scope.passwordFields.confirmation) {
                        return "******";
                    }
                    return "";
                }

                function setToPlaceholder() {
                    $scope.passwordFields.password = undefined;
                    $scope.passwordFields.confirmation = undefined;
                }
            }]);
    });
